export default "__VITE_ASSET__CqsrJpKg__"